// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__18Mwd","iconSpin":"Loading_iconSpin__Nf_Zl"};